import { c as _c } from "react/compiler-runtime";
import { Typography, DirectionIcon } from "@/shared/ui/atoms";
import { CustomButton } from "@/shared/ui/molecules";
type EvidenceCardProps = {
  /** 소분류를 제목으로 올린다. 대분류보다 이 병원의 특징을 구체적으로 말해 준다 */
  title: string;
  count: string;
  /** 근거 리뷰 문장. 부정 항목이면 넘기지 않는다 */
  quote?: string;
  onClick: () => void;
};

/**
 * 상세보기의 분석 행과 같은 모양을 쓴다. 회색 컨테이너 안에 놓이는 흰색 행이므로
 * 이 컴포넌트는 배경을 스스로 칠하지 않는다.
 */
const EvidenceCard = t0 => {
  const $ = _c(16);
  const {
    title,
    count,
    quote,
    onClick
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <Typography size={14} lineHeight={18} className="min-w-0 text-[#46474C] font-semibold tracking-[-0.28px] break-words [overflow-wrap:anywhere]">{title}</Typography>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== count) {
    t2 = <Typography size={12} lineHeight={18} className="text-gray-400 font-medium">{count}</Typography>;
    $[2] = count;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <DirectionIcon size={20} rotate={270} className="text-gray-300" />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2) {
    t4 = <div className="flex shrink-0 items-center">{t2}{t3}</div>;
    $[5] = t2;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t1 || $[8] !== t4) {
    t5 = <div className="flex w-full min-w-0 items-center justify-between gap-2">{t1}{t4}</div>;
    $[7] = t1;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== quote) {
    t6 = quote && <Typography size={13} lineHeight={19} className="w-full border-l-2 border-gray-200 pl-2 text-gray-500 font-medium tracking-[-0.26px] line-clamp-2 break-words [overflow-wrap:anywhere]">{quote}</Typography>;
    $[10] = quote;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== onClick || $[13] !== t5 || $[14] !== t6) {
    t7 = <CustomButton className="flex w-full min-w-0 flex-col items-start gap-1 rounded-[5px] bg-white px-2 py-1.5 text-left" onClick={onClick}>{t5}{t6}</CustomButton>;
    $[12] = onClick;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};
export default EvidenceCard;